import React, { useState } from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ChatPopup from "./ChatPopup";
import { Badge } from "@mui/material";

function Chat({ setOpenMessage, openMessage, setIsNotificationOpen }) {
  const [totalUnreadMessages, setTotalUnreadMessages] = useState("");

  const handleChat = () => {
    setOpenMessage(!openMessage);
    setIsNotificationOpen(false);
  };
  return (
    <div>
      <Badge color="secondary" badgeContent={totalUnreadMessages}>
        <ChatBubbleOutlineIcon
          className="text cursor-pointer"
          sx={{ fontSize: 40 }}
          onClick={handleChat}
        />
      </Badge>
      <ChatPopup
        setOpenMessage={setOpenMessage}
        openMessage={openMessage}
        setTotalUnreadMessages={setTotalUnreadMessages}
      />
    </div>
  );
}

export default Chat;
